import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { CoverageByPriceData, PriceConstants } from '../../typings/domain';
import { CurrencyCode } from '../../typings/graphql-grid';
import { ContextPhrasePriceEditorPopup } from '../ContextPhrasePriceEditorPopup/ContextPhrasePriceEditorPopup';
import { EditableCell } from '../EditableCell/EditableCell';
import { MoneyText } from '../MoneyText/MoneyText';

export interface PhraseContextMoneyCellEditorProps {
    cls?: string;
    currency: CurrencyCode;
    priceContext?: number;
    error?: string;
    isSaving: boolean;
    onCancel: () => void;
    priceLimit: PriceConstants;
    onSave: (value: number) => void;
    priceForCoverage: Array<CoverageByPriceData>;
    isCpmBanner: boolean;
}

interface PhraseContextMoneyCellEditorState {
    isPopupOpened: boolean;
}

export class PhraseContextMoneyEditor extends React.Component<
    PhraseContextMoneyCellEditorProps,
    PhraseContextMoneyCellEditorState
> {
    constructor(props: PhraseContextMoneyCellEditorProps) {
        super(props);

        this.state = {
            isPopupOpened: false
        };
    }

    componentDidUpdate(prevProps: PhraseContextMoneyCellEditorProps) {
        if (
            (prevProps.isSaving !== this.props.isSaving || prevProps.error !== this.props.error) &&
            !this.props.isSaving &&
            !this.props.error
        ) {
            this.setState({
                isPopupOpened: false
            });
        }
    }

    render() {
        const { isPopupOpened } = this.state;

        const { priceContext, cls } = this.props;

        return (
            <>
                <EditableCell
                    onClick={this.switchPopupState}
                    isActive={isPopupOpened}
                    cls={classNames(cls, Bem.cls('phrase-context-money-editor'))}
                >
                    {priceContext ? <MoneyText num={priceContext} fractionalPartLength={2} /> : '–'}
                </EditableCell>
                {this.getPopup()}
            </>
        );
    }

    private switchPopupState = () => {
        const { isPopupOpened } = this.state;

        this.setState({
            isPopupOpened: !isPopupOpened
        });
    };

    private getPopup = () => {
        const { isPopupOpened } = this.state;
        const {
            priceForCoverage,
            currency,
            onSave,
            error,
            isSaving,
            priceLimit,
            priceContext,
            isCpmBanner
        } = this.props;

        if (!isPopupOpened) {
            return null;
        }

        return (
            <ContextPhrasePriceEditorPopup
                priceForCoverage={priceForCoverage}
                priceContext={priceContext}
                currency={currency}
                onSave={onSave}
                error={error}
                anchor={this}
                isSaving={isSaving}
                isPopupOpen={isPopupOpened}
                onCancel={this.cancel}
                priceLimit={priceLimit}
                isCpmBanner={isCpmBanner}
            />
        );
    };

    private cancel = () => {
        this.setState({
            isPopupOpened: false
        });

        this.props.onCancel();
    };
}
